import * as contentful from "contentful";

const space = "hwqnbx905qdp";

const client = contentful.createClient({
  space,
  accessToken: import.meta.env.VITE_CONTENTFUL_API_TOKEN,
  environment: "main",
});

export { client as contentfulClient };

/**
 * Usage example:
 *
 * import { contentfulClient } from "@/lib/contentful-client";
 *
 * // Fetch entries of a specific content type
 * const entries = await contentfulClient.getEntries({
 *   content_type: "your-content-type-id",
 * });
 *
 * // Fetch a specific entry by ID
 * const entry = await contentfulClient.getEntry("entry-id");
 *
 * // Fetch assets
 * const assets = await contentfulClient.getAssets();
 */
